import React from "react";
import PropTypes from "prop-types";
import { Card, FormLayout, Select, TextField } from "@shopify/polaris";

const Title = (props) => {
  const { data, onChange, variantOption = [], error, cms, locations = [] } = props;

  const handleTitle = (key, value) => {
    onChange((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const renderTextField = () => {
    const textFields = [];
    Object.keys(variantOption).forEach((variantLabel) => {
      if (variantOption[variantLabel]) {
        const hasError =
          (!data[variantLabel] || (data[variantLabel] && data[variantLabel].trim() === "")) &&
          error[variantLabel] &&
          `${cms("label.fill")} ${variantOption[variantLabel]}`;
        if (variantOption[variantLabel] === "Location" && locations && locations.length) {
          textFields.push(
            <Select
              label={`${variantOption[variantLabel]}*`}
              placeholder="Select Locations"
              options={locations}
              onChange={(value) => handleTitle(variantLabel, value)}
              value={data[variantLabel] || ""}
            />
          );
          return;
        }
        const textField = (
          <TextField
            key={variantLabel}
            id={variantLabel}
            label={`${variantOption[variantLabel]}*`}
            value={data[variantLabel] || ""}
            onChange={(value) => handleTitle(variantLabel, value)}
            placeholder={variantOption[variantLabel]}
            error={hasError}
          />
        );
        textFields.push(textField);
      }
    });
    return textFields;
  };

  return (
    <Card title={cms("section.title")} sectioned>
      <FormLayout>{renderTextField()}</FormLayout>
    </Card>
  );
};

Title.propTypes = {
  cms: PropTypes.func.isRequired,
  data: PropTypes.objectOf(PropTypes.string).isRequired,
  error: PropTypes.objectOf(PropTypes.bool).isRequired,
  onChange: PropTypes.func.isRequired,
  variantOption: PropTypes.objectOf(PropTypes.string),
};

Title.defaultProps = {
  variantOption: [],
};

export default Title;
